import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Button,
  ICONS,
  PLATFORM_THEME_COLORS,
  Typography,
  TYPOGRAPHY_SIZE,
} from '@thinknet-gmbh/platform-common-ui';
import { PERMISSION_ACTIONS, PLATFORM_PERMISSIONS } from '@thinknet-gmbh/platform-common';

import { useRouteQuery } from 'src/common/helpers';
import { CreateAppraisalInterview } from 'src/pages/employee/components/create-appraisal-interview';
import { useGetAppraisalInterviews } from 'src/hooks/appraisal-interview/get-appraisal-interviews.hook';
import PermissionCheck from 'src/components/permission-check';

import { EmployeeInterviewListTable } from './components/employee-interview-list-table';
import { HeaderContainer } from './employee-interview.styles';

const EmployeeInterview = () => {
  const { t } = useTranslation('employee');
  const query = useRouteQuery();
  const id: string = query.get('id') || '';
  const [isOpenedCreateModal, setIsOpenedCreateModal] = useState(false);
  const { appraisalInterviews, paginationConfig, onTableChange } = useGetAppraisalInterviews(id);

  return (
    <div>
      <CreateAppraisalInterview
        isOpened={isOpenedCreateModal}
        onClose={() => setIsOpenedCreateModal(false)}
        memberId={id}
      />
      <HeaderContainer>
        <Typography weight="bold" size={TYPOGRAPHY_SIZE.medium}>
          {t('labels.employeeInterview')}
        </Typography>
        <PermissionCheck
          permission={PLATFORM_PERMISSIONS.memberManagement}
          action={PERMISSION_ACTIONS.create}
        >
          <Button
            type="primary"
            icon={ICONS.plus}
            iconColor={PLATFORM_THEME_COLORS.primary.white}
            onClick={() => setIsOpenedCreateModal(true)}
          >
            {t('employeeInterview.labels.createInterview')}
          </Button>
        </PermissionCheck>
      </HeaderContainer>
      <EmployeeInterviewListTable
        employeeId={id}
        dataSource={appraisalInterviews}
        paginationConfig={paginationConfig}
        onTableChange={onTableChange}
      />
    </div>
  );
};

export default EmployeeInterview;
